import { render, staticRenderFns } from "./MotherVue.vue?vue&type=template&id=62057cde&scoped=true&"
import script from "./MotherVue.vue?vue&type=script&lang=js&"
export * from "./MotherVue.vue?vue&type=script&lang=js&"
import style0 from "./MotherVue.vue?vue&type=style&index=0&id=62057cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62057cde",
  null
  
)

export default component.exports